// This file imports all images statically so webpack can process them

import * as obsFeatureImages from './StreamYardVsObs/featureCardImages';
import * as obsComparisonImages from './StreamYardVsObs/comparisonImage';

export const competitorImages = {
	obs: obsFeatureImages,
} as const;

export type CompetitorImages = typeof competitorImages;

export const comparisonImages = {
	obs: obsComparisonImages,
} as const;

export type ComparisonImages = typeof comparisonImages;

export type ComparisonImageSet = {
	streamyardView: string;
	competitorView: string;
};
